module.exports = __webpack_public_path__ + "static/media/Rectangle28.cc790b04.png";